import script from "./ShopingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopingCart.vue?vue&type=script&setup=true&lang=js"

import "./ShopingCart.vue?vue&type=style&index=0&id=3e6cee9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6cee9c"]])

export default __exports__